import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Document imports from bg folder
import prezentaciaTS870P from '../../assets/documents/bg/Презентация-Continental-TS-870-P.pdf';
import formularGarancia from '../../assets/documents/bg/Формуляр-за-гаранция.doc';
import primerSnimka from '../../assets/documents/bg/Пример-за-снимка.jpg';
import garantsionniUslovia from '../../assets/documents/bg/гаранционни-условия-Continental.docx';
import vwBroshura from '../../assets/documents/bg/VW-Winter-leaflet_A4_2025_pages_final.pdf';
import audiBroshura from '../../assets/documents/bg/winter-tyres_Audi 2025_А4_PAGES.pdf';
import rezultatiProdajbi from '../../assets/documents/bg/Резултати от продажбите от 1-9.2024г.xlsx';

// Document imports from ro folder
import formularReclamatii from '../../assets/documents/ro/Formular proces verbal reclamatii anvelope.pdf';
import declaratieConformitate from '../../assets/documents/ro/Declaratie de conformitate si certificat garantie.pdf';
import notificareRar from '../../assets/documents/ro/Notificare RAR 1.pdf';
import continentalAllSeason from '../../assets/documents/ro/Continental AllSeason Contact 2.pdf';
import continentalManual from '../../assets/documents/ro/Continental Manual Anvelope.pdf';
import continentalSsr from '../../assets/documents/ro/Continental SSR.pdf';
import continentalUltraContact from '../../assets/documents/ro/Continental UltraContact NXT.pdf';
import premiiAnvelope from '../../assets/documents/ro/Premii anvelope vară Continental.pdf';
import contiGarant from '../../assets/documents/ro/Conti-Garant.zip';

// Document imports from sl folder
import miniCenik from '../../assets/documents/sl/mini_cenik_2023.zip';
import internaNavodila from '../../assets/documents/sl/internanavodilazaservisdopolnilnocontinental.pdf';
import jamstveniZapisnik from '../../assets/documents/sl/jamstvenizapisnik-11052018.pdf';
import garancijskiList from '../../assets/documents/sl/garancijski-list.pdf';
import continentalZimske from '../../assets/documents/sl/Continental_gume_2025_26_zimske.pdf';
import continentalCeloletne from '../../assets/documents/sl/Continental_gume_2025_celoletne.pdf';
import continentalLetne from '../../assets/documents/sl/Continental_letne_2025.pdf';
import semperitZimske from '../../assets/documents/sl/Semperit_zimske_2025_26.pdf';
import barumZimske from '../../assets/documents/sl/Barum_zimske_2025_26.pdf';

// style components
import Button from './style/Button';
import Icon from './style/Icon';
import DocumentTypeContainer from './style/DocumentTypeContainer';
import Title from './style/Title.style';
import Container from './style/Container.style';

const PageWrapper = styled.div`
  background-color: #f9fafb;
  min-height: 100vh;
  width: 100%;
`;

// Hardcoded documents data organized by market
const documentsDataByMarket = {
  bg: [
    {
      id: 'presentations',
      name: 'Допълнителна информация – презентации и обучения',
      files: [
        {
          id: 'ts870p',
          name: 'Презентация Continental TS 870 P',
          url: prezentaciaTS870P,
          originalName: 'Презентация-Continental-TS-870-P.pdf',
        },
      ],
    },
    {
      id: 'warranty',
      name: 'Гаранция',
      files: [
        {
          id: 'warranty-form',
          name: 'Формуляр за гаранция',
          url: formularGarancia,
          originalName: 'Формуляр-за-гаранция.doc',
        },
        {
          id: 'sample-photo',
          name: 'Примерна снимка',
          url: primerSnimka,
          originalName: 'Пример-за-снимка.jpg',
        },
        {
          id: 'warranty-conditions',
          name: 'гаранционни условия Continental',
          url: garantsionniUslovia,
          originalName: 'гаранционни-условия-Continental.docx',
        },
      ],
    },
    {
      id: 'brochures',
      name: 'Брошури',
      files: [
        {
          id: 'vw-brochure',
          name: 'Зимна брошура VW 2025',
          url: vwBroshura,
          originalName: 'VW-Winter-leaflet_A4_2025_pages_final.pdf',
        },
        {
          id: 'audi-brochure',
          name: 'Зимна брошура Audi 2025',
          url: audiBroshura,
          originalName: 'winter-tyres_Audi 2025_А4_PAGES.pdf',
        },
      ],
    },
    {
      id: 'sales',
      name: 'Резултати от продажби',
      files: [
        {
          id: 'sales-2024',
          name: 'Резултати от продажбите от 1-9.2024',
          url: rezultatiProdajbi,
          originalName: 'Резултати от продажбите от 1-9.2024г.xlsx',
        },
      ],
    },
  ],
  // Slovenia documents
  sl: [
    {
      id: 'mini-cenik',
      name: 'Mini cenik',
      files: [
        {
          id: 'mini-cenik-2023',
          name: 'Mini cenik',
          url: miniCenik,
          originalName: 'mini_cenik_2023.zip',
        },
      ],
    },
    {
      id: 'dopolnilno-jamstvo',
      name: 'Dopolnilno jamstvo',
      files: [
        {
          id: 'interna-navodila',
          name: 'Interna navodila za servis',
          url: internaNavodila,
          originalName: 'internanavodilazaservisdopolnilnocontinental.pdf',
        },
        {
          id: 'jamstveni-zapisnik',
          name: 'Jamstveni zapisnik',
          url: jamstveniZapisnik,
          originalName: 'jamstvenizapisnik-11052018.pdf',
        },
      ],
    },
    {
      id: 'garancija',
      name: 'Garancija',
      files: [
        {
          id: 'garancijski-list',
          name: 'Garancijski list',
          url: garancijskiList,
          originalName: 'garancijski-list.pdf',
        },
      ],
    },
    {
      id: 'aktualni-letaki',
      name: 'Aktualni letaki',
      files: [
        {
          id: 'continental-zimske',
          name: 'Continental (zima)',
          url: continentalZimske,
          originalName: 'Continental_gume_2025_26_zimske.pdf',
        },
        {
          id: 'continental-celoletne',
          name: 'Continental (celoletne)',
          url: continentalCeloletne,
          originalName: 'Continental_gume_2025_celoletne.pdf',
        },
        {
          id: 'continental-letne',
          name: 'Continental (letne)',
          url: continentalLetne,
          originalName: 'Continental_letne_2025.pdf',
        },
        {
          id: 'semperit',
          name: 'Semperit',
          url: semperitZimske,
          originalName: 'Semperit_zimske_2025_26.pdf',
        },
        {
          id: 'barum',
          name: 'Barum',
          url: barumZimske,
          originalName: 'Barum_zimske_2025_26.pdf',
        },
      ],
    },
  ],
  // Romania documents
  ro: [
    {
      id: 'warranty-claims',
      name: 'Garanție suplimentară',
      files: [
        {
          id: 'formular-reclamatii',
          name: 'Formular proces verbal reclamatii anvelope',
          url: formularReclamatii,
          originalName: 'Formular proces verbal reclamatii anvelope.pdf',
        },
      ],
    },
    {
      id: 'warranty-certs',
      name: 'Garanție suplimentară',
      files: [
        {
          id: 'declaratie-conformitate',
          name: 'Declaratie de conformitate si certificat garantie',
          url: declaratieConformitate,
          originalName: 'Declaratie de conformitate si certificat garantie.pdf',
        },
        {
          id: 'notificare-rar',
          name: 'Notificare RAR',
          url: notificareRar,
          originalName: 'Notificare RAR 1.pdf',
        },
      ],
    },
    {
      id: 'conti-garant',
      name: 'Conti Garant',
      files: [
        {
          id: 'conti-garant',
          name: 'Conti Garant',
          url: contiGarant,
          originalName: 'Conti-Garant.zip',
        },
      ],
    },
    {
      id: 'brochures',
      name: 'Broșură actuală',
      files: [
        {
          id: 'continental-allseason',
          name: 'Continental AllSeason Contact',
          url: continentalAllSeason,
          originalName: 'Continental AllSeason Contact 2.pdf',
        },
        {
          id: 'continental-manual',
          name: 'Continental Manual Anvelope',
          url: continentalManual,
          originalName: 'Continental Manual Anvelope.pdf',
        },
        {
          id: 'continental-ssr',
          name: 'Continental SSR',
          url: continentalSsr,
          originalName: 'Continental SSR.pdf',
        },
        {
          id: 'continental-ultracontact',
          name: 'Continental UltraContact NXT',
          url: continentalUltraContact,
          originalName: 'Continental UltraContact NXT.pdf',
        },
        {
          id: 'premii-anvelope',
          name: 'Premii anvelope vară Continental',
          url: premiiAnvelope,
          originalName: 'Premii anvelope vară Continental.pdf',
        },
      ],
    },
  ],
};

const getFileType = (filename) => {
  const ext = filename.split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (ext === 'doc' || ext === 'docx') return 'doc';
  if (ext === 'xls' || ext === 'xlsx') return 'xls';
  if (ext === 'zip') return 'zip';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return 'image';
  return 'other';
};

const getFileIcon = (fileType) => {
  switch (fileType) {
    case 'pdf':
      return 'file-pdf-outline';
    case 'doc':
      return 'file-word-box';
    case 'xls':
      return 'file-excel-box';
    case 'zip':
      return 'zip-box';
    case 'image':
      return 'file-image-outline';
    default:
      return 'file-document-outline';
  }
};

const DocumentsContainer = () => {
  const { i18n } = useTranslation();

  // Get documents for current market based on language
  const documentsData = documentsDataByMarket[i18n.language] || [];

  const downloadDocument = (url) => {
    window.open(url, '_blank');
  };

  return (
    <PageWrapper>
      <Container>
        {documentsData.map((category) => (
          <DocumentTypeContainer key={category.id}>
            <Title>{category.name}</Title>
            {category.files.map((file) => {
              const fileType = getFileType(file.originalName);
              return (
                <Button
                  key={file.id}
                  onClick={() => downloadDocument(file.url)}
                >
                  {file.name}
                  <Icon className={`mdi mdi-${getFileIcon(fileType)}`} />
                </Button>
              );
            })}
          </DocumentTypeContainer>
        ))}
      </Container>
    </PageWrapper>
  );
};

export default DocumentsContainer;
